<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>客户项目</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/project' }">项目列表</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/project/detail?id=${query.id}` }">项目详情</el-breadcrumb-item>
        <el-breadcrumb-item>合同详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form myform">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="left">
        <div class="formtitle">合同信息</div>
        <template v-if="level == 1">
          <el-form-item label="合同编号：" prop="contract_no">
            <el-col :span="12">
              <el-input placeholder="请正确填写合同编号" maxlength="100" v-model="form.contract_no" clearable/>
            </el-col>
          </el-form-item>        
        </template>
        <el-form-item label="选择合同类型：" prop="contract_type">
          <el-col :span="12">
            <el-select v-model="form.contract_type" placeholder="请选择" style="margin-right: 0; width: 100%;"
              @change="contractChange"
              :disabled="(form.status == '5' || (form.contract_no && form.contract_no != 'TBD')) && level != 1">
              <el-option label="单一合同" value="1"></el-option>
              <el-option label="框架合同" value="2"></el-option>
              <el-option label="补充合同" value="3"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <!-- 所属合同 -->
        <el-form-item label="所属合同：" prop="parent_project" v-if="form.contract_type == 3">
          <el-col :span="12">
            <el-select v-model="form.parent_project_id" placeholder="请选择" style="margin-right: 0; width: 100%;" clearable
              filterable :disabled="(form.status == '5' || (form.contract_no && form.contract_no != 'TBD')) && level != 1">
              <el-option :label="v.contract_no + '-' + v.contract_name" :value="v.id" v-for="(v, i) in projectList"
                :key="i"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="合同时间：" prop="contract_time">
          <el-col :span="12">
            <el-date-picker v-model="form.contract_time" type="datetimerange" range-separator="--"
              start-placeholder="合同开始时间" end-placeholder="合同结束时间" style="width:100%;" @change="contractTime"
              :disabled="(form.status == '5' || (form.contract_no && form.contract_no != 'TBD')) && level != 1">
            </el-date-picker>
          </el-col>
        </el-form-item>
        <template v-if="form.contract_type != 2">
          <el-form-item label="合同金额：" prop="contract_amount">
            <el-col :span="12">
              <el-input placeholder="请正确填写合同含税金额" maxlength="100" v-model="form.contract_amount" clearable
                @change="taxChange" :disabled="(form.status == '5' || (form.contract_no && form.contract_no != 'TBD')) && level != 1" />
            </el-col>
          </el-form-item>
          <el-form-item label="税率：" prop="tax_rate">
            <el-col :span="12">
              <el-select v-model="form.tax_rate" placeholder="请选择" style="margin-right: 0; width: 100%;"
                @change="taxChange" :disabled="(form.status == '5' || (form.contract_no && form.contract_no != 'TBD')) && level != 1">
                <el-option label="0%" value="0"></el-option>
                <el-option label="1%" value="1"></el-option>
                <el-option label="3%" value="3"></el-option>
                <el-option label="6%" value="6"></el-option>
                <el-option label="13%" value="13"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="税额：" prop="tax">
            <el-col :span="12">
              {{ form.tax }}
            </el-col>
          </el-form-item>
        </template>
        <!-- 电子合同附件 -->
        <template>
          <ul class="anlist">
            <li v-for="(item, index) in fileList" :key="index">
              <div class="abox">
                <el-form-item :label='`电子合同附件${index + 1}：`'>
                  <!-- 选择文件 -->
                  <el-col :span="3" v-if="form.status != '5'">
                    <el-upload class="upload-demo" ref="upFile" action="#" :limit="1" :show-file-list="false"
                      :auto-upload="false" accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png" :file-list="item.flist"
                      :on-change="(arg) => uploadFile(arg, 'fileList', 'upFile', item, index)">
                      <el-button size="small" style="width: 80px;">选择文件</el-button>
                    </el-upload>
                  </el-col>
                  <!-- 文件预览及下载 -->
                  <template v-if="item.origin_name">
                    <el-col :span="10">
                      <el-col :span="18">
                        <div class="origin-name">{{
                          item.origin_name }}</div>
                      </el-col>
                      <el-col :span="4">
                        <el-link type="primary" style="margin-right:5px" :href="item.httpFile"
                          target="_blank">查看</el-link>
                      </el-col>
                    </el-col>
                  </template>
                </el-form-item>
              </div>
              <el-button class="bbtn" v-if="form.status != '5'" icon="el-icon-minus"
                @click="removeImage(fileList, index)" circle></el-button>
            </li>
            <el-button type="primary" style="margin: 0 0 15px 150px" class="addbtn" v-if="form.status != '5'" @click="addImage(fileList)">新增电子合同</el-button>
          </ul>
        </template>
        <!-- 盖章合同附件 -->
        <template>
          <ul class="anlist">
            <li v-for="(item, index) in fileList1" :key="index">
              <div class="abox">
                <el-form-item :label='`盖章合同附件${index + 1}：`'>
                  <!-- 选择文件 -->
                  <el-col :span="3" v-if="(form.contract_no && form.contract_no != 'TBD') && form.status != '5'">
                    <el-upload class="upload-demo" ref="upFile1" action="#" :limit="1" :show-file-list="false"
                      :auto-upload="false" accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png" :file-list="item.flist"
                      :on-change="(arg) => uploadFile(arg, 'fileList1', 'upFile1', item, index)">
                      <el-button size="small" style="width: 80px;">选择文件</el-button>
                    </el-upload>
                  </el-col>
                  <el-col :span="3" v-else-if="form.status != '5'">
                    <el-button size="small" style="width: 80px;" @click="showWrongFn">选择文件</el-button>
                  </el-col>
                  <!-- 文件预览及下载 -->
                  <template v-if="item.origin_name">
                    <el-col :span="10">
                      <el-col :span="18">
                        <div class="origin-name">{{
                          item.origin_name }}</div>
                      </el-col>
                      <el-col :span="4">
                        <el-link type="primary" style="margin-right:5px" :href="item.httpFile"
                          target="_blank">查看</el-link>
                      </el-col>
                    </el-col>
                  </template>
                </el-form-item>
              </div>
              <el-button class="bbtn" v-if="form.status != '5'" icon="el-icon-minus"
                @click="removeImage1(fileList1, index)" circle></el-button>
            </li>
            <el-button type="primary" style="margin: 0 0 15px 150px" class="addbtn" v-if="form.status != '5'" @click="addImage1(fileList1)">新增盖章合同</el-button>
          </ul>
        </template>
        <el-form-item label="备注：" prop="info">
          <el-col :span="12">
            <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
              v-model="form.info" :disabled="form.status == '5'">
            </el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="">
          <el-col :span="10">
            <el-button @click="resetForm('form')">取消</el-button>
            <el-button type="primary" @click="submitForm('form')">保存</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </div>
  </el-main>
</template>

<script>
import * as api from '@/api'
import { timeFormat } from '@/utils/index.js'
import store from '@/store'
export default {
  name: 'probill',
  data() {
    return {
      nodeLimtList: [],
      level: '',
      clientList: [],
      userList: [],
      projectList: [],
      brandArr: {
        brandList: []
      },
      form: {
        project_id: '',
        //合同信息
        contract_no: '',
        contract_type: '',
        parent_project_id: '',
        contract_time: ['', ''],
        contract_start_time: '',
        contract_end_time: '',
        contract_amount: '',
        tax_rate: '6',
        tax: '',
        info: '',
        atta_str: '', //合同附件数组, file_type 1电子合同 2盖章合同
        atta_del: '', //删除的文件id(用英文,隔开 如: 13,14,15)
        //项目信息-收款计划
        bill_str: '',
        bill_del: '',
      },
      billList: [
        { bill_name: '', amount: '', type: '1', bill_day: '', bill_date: '', estimate_date: '', bill_id: '', }//bill_id 计划id 新增为0，编辑不为空
      ],
      p: 1,
      amount_tobill: '0.00', //项目剩余金额
      del_bill_list: [],
      rules: {
        contract_time: [
          {
            required: true,
            message: '请选择合同时间',
            trigger: 'change',
          },
        ],
      },
      fileList: [
        { origin_name: '', file_name: '', httpFile: '', file_id: '', flist: [] }
      ],
      fileList1: [
        { origin_name: '', file_name: '', httpFile: '', file_id: '', flist: [] }
      ],
      del_atta_list: [],
      del_atta_list1: [],
    }
  },
  created() {
    this.query = this.$route.query
    this.query.id && this.getDetail(this.query.id)
  },
  mounted() {

  },
  watch: {
    ['form.pay_bank_account'](val) {
      if (val != undefined) {
        this.$nextTick(() => {
          this.form.pay_bank_account = val.replace(/\D/g, '').replace(/....(?!$)/g, '$& ');
        });
      }
    }
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    //选择文件
    uploadFile(file, fileList, ref, item, index) {
      let formData = new FormData();
      formData.append("file_arr", file.raw);
      formData.append("type", 3);
      api.uploadFile(formData)
        .then((res) => {
          this[fileList][index] = {
            ...item,
            origin_name: res.origin_name,
            file_name: res.file_name,
            httpFile: res.httpFile,
          }
          this.$forceUpdate()
          this.$refs[ref][index].clearFiles();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addBill(arr) {
      arr.push({
        bill_id: '',
        amount: '',
        type: '1',
        bill_day: '',
        bill_date: '',
        estimate_date: '',
      });
    },
    removeBill(arr, index) {
      this.del_bill_list.push(arr[index].id);
      console.log(this.del_bill_list);
      arr = arr.splice(index, 1);
    },
    addImage(arr) {
      arr.push({
        origin_name: '', file_name: '', httpFile: '', id: '', flist: []
      });
    },
    removeImage(arr, index) {
      if (arr[index].id) {
        this.del_atta_list.push(arr[index].id);
      }
      console.log(this.del_atta_list);
      arr = arr.splice(index, 1);
    },
    addImage1(arr) {
      arr.push({
        origin_name: '', file_name: '', httpFile: '', id: '', flist: []
      });
    },
    removeImage1(arr, index) {
      if (arr[index].id) {
        this.del_atta_list1.push(arr[index].id);
      }
      console.log(this.del_atta_list1);
      arr = arr.splice(index, 1);
    },
    taxChange() {//计算税额，同时合同金额变化，重新计算余值
      this.billChange()
      const amount = Number(this.form.contract_amount);
      const taxRate = Number(this.form.tax_rate);
      this.form.tax = (amount / ((100 + taxRate) / 100) * taxRate / 100).toFixed(2)
    },
    billChange() {//项目待收金额计算
      const total = Number(this.form.contract_amount)
      let temp = 0
      this.billList.forEach(item => {
        temp += Number(item.amount)
      })
      const amount_tobill = (total - temp)
      console.log('total:',total, 'temp:',temp, 'amount_tobill:', amount_tobill,);
      if (amount_tobill >= 0) {
        this.amount_tobill = amount_tobill.toFixed(2)//取两位
      }
      else {
        this.amount_tobill = '项目剩余待收金额为负,请重新填写'
      }
    },
    billTypeChange(v, index) {
      this.billList[index].type = v;
      this.billList[index].bill_day = '';
      this.billList[index].bill_date = '';
      this.billList[index].estimate_date = '';
    },
    contractChange(v) {
      if (v == 3) {
        this.$fly
          .post('apiProject_getList.html', {
            per_page: 5000,
            client_company: this.form.client_company,
            brand: this.form.brand,
            search_source: 2,
          })
          .then((res) => {
            this.projectList = res.itemList
          })
      }
    },
    //项目时间调整
    contractTime() {
      const time = this.form.contract_time
      this.form.contract_start_time = this.fdate(time[0])
      this.form.contract_end_time = this.fdate(time[1])
    },
    async getDetail(id) {
      this.checkUrlFn()
      this.$fly
        .post('apiProject_getDetail.html', {
          project_id: id,
        })
        .then((res) => {
          let form = res.itemArr
          delete form.is_apply
          form.tax_rate = form.tax_rate ? form.tax_rate : '6'
          //修改0000-00-00错误显示1899年情况
          form.contract_start_time = timeFormat(form.contract_start_time)
          form.contract_end_time = timeFormat(form.contract_end_time)
          form.finish_time = timeFormat(form.finish_time)
          //初始contract_time
          form.contract_time = ['', '']
          form.contract_time[0] = form.contract_start_time
          form.contract_time[1] = form.contract_end_time
          this.billList = res.billList.map((item) => {
            item.bill_date = timeFormat(item.bill_date)
            item.estimate_date = timeFormat(item.estimate_date)
            return item
          })
          this.fileList = res.itemArr.fileList.filter(item => item.file_type == '1').map((item) => {
            delete item.project_id
            delete item.create_time
            item.flist = []
            return item
          })
          this.fileList1 = res.itemArr.fileList.filter(item => item.file_type == '2').map((item) => {
            delete item.project_id
            delete item.create_time
            item.flist = []
            return item
          })
          //防空情况
          if (this.billList.length === 0) {
            this.billList = [{ amount: '', bill_name: '', type: '1', bill_id: '', bill_day: '', bill_date: '', estimate_date: '', }]
          }
          if (this.fileList.length === 0) {
            this.fileList = [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }]
          }
          if (this.fileList1.length === 0) {
            this.fileList1 = [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }]
          }
          this.form = form
          setTimeout(() => {
            //权限
            this.level = store.state.level
            this.realName = store.state.realName
          }, 200);
          this.billChange()
          this.contractChange(this.form.contract_type)
        })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addUpdateProject()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addUpdateProject() {
      this.form.project_id = this.query.id || ''
      this.form.option = this.form.id ? '2' : '1'
      // 替换掉id为bill_id
      let $billList = this.billList.map((item) => {
        Object.keys(item).forEach(key => {
          if (key == 'id') {
            item['bill_id'] = item[key]
            delete item[key]
          }
        })
        return item
      })
      $billList = $billList.map(({ bill_name, bill_date, amount, type, bill_day, estimate_date, bill_id }) => {
        return { bill_name, bill_date, amount, type, bill_day, estimate_date, bill_id }
      })
      this.billList = $billList
      //替换掉id为file_id
      let fileList = this.fileList.map((item) => {
        delete item.flist
        delete item.httpFile
        item.file_type = 1
        return item
      })
      let fileList1 = this.fileList1.map((item) => {
        delete item.flist
        delete item.httpFile
        item.file_type = 2
        return item
      })
      fileList = fileList.concat(fileList1)
      let del_atta_list = this.del_atta_list
      let del_atta_list1 = this.del_atta_list1
      const del_atta = del_atta_list.concat(del_atta_list1)
      const $fileList = fileList.map((item) => {
        Object.keys(item).forEach(key => {
          if (key == 'id') {
            item['file_id'] = item[key] || 0
            console.log(item['file_id']);
            delete item[key]
          }
        })
        return item
      })
      fileList = $fileList
      const tempForm = JSON.parse(JSON.stringify(this.form))
      delete tempForm.fileList
      delete tempForm.status
      delete tempForm.project_start_time
      delete tempForm.project_end_time
      this.$fly
        .post('apiProject_addUpdate.html', {
          ...tempForm,
          bill_str: JSON.stringify(this.billList),
          bill_del: this.del_bill_list.toString(),
          atta_str: JSON.stringify(fileList),
          atta_del: del_atta.toString()
        })
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.message)
          }
          this.$router.go(-1)
        })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$router.go(-1)
    },
    showWrongFn() {
      this.$message.error('请先获取合同编号')
    },
  },
}
</script>

<style lang="scss" scoped>
.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .form {
    @extend %box;
    padding: 30px;
    margin-bottom: 20px;

    .anlist {
      padding: 0;
      flex-flow: column nowrap;

      li {
        position: relative;
        padding: 0;

        .abtn {
          position: absolute;
          top: 0;
          left: 65%;
        }

        .bbtn {
          position: absolute;
          top: 0;
          left: 60%;
        }
      }
    }
  }

  .formtitle {
    position: relative;
    left: -50px;
    margin-bottom: 30px;
    font-size: 28px;
    line-height: 48px;
    font-weight: 600;
  }
}</style>
